import React, { useContext, useEffect, useState } from "react";
import { Collapse, Empty, message } from "antd";
import Button from "../../../common/Button";
import "./style.scss";
import { Modal } from "antd";
import SequentialDetail from "../SequentialDetail";
import CreateAngel from "../CreateAngel";
import {
  useGetAllAngles,
  useGetGuidelineData,
} from "../../../hooks/useGuidelines";
import { CloseOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { GuidelinesSelectedCategoryContext } from "../../../context/guidelinesProvider";

const CreateSet = ({ update }) => {
  const [imageSet, setImageSet] = useState([]);
  const {
    guide_selectedCategoryName,
    guide_selectedSubCategoryName,
    guide_selectedCategoryId,
    guide_selectedSubCategoryId,
    guide_selectedClientId,
  } = useContext(GuidelinesSelectedCategoryContext);
  const [isSequentialDetails, setIsSequentialDetail] = useState(false);
  const [isCreateAngle, setIsCreateAngle] = useState(false);
  const [draggedItemIndex, setDraggedItemIndex] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(500);
  const [anglesList, setAnglesList] = useState([]);
  const [sequentialDetail, setSequentialDetail] = useState([]);
  const params = useParams();
  const handleDragStart = (index) => {
    setDraggedItemIndex(index);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  function groupByShootType(data) {
    const groupedData = {};
    data.forEach((item) => {
      const { shootType } = item;
      if (!groupedData[shootType]) {
        groupedData[shootType] = { shootType, angles: [] };
      }
      groupedData[shootType].angles.push(item);
    });
    return Object.values(groupedData);
  }

  const onSuccessGuidelineData = (res) => {
    if (res.status === 200) {
      const filteredAngleSet = res.data.data?.angleSets.filter((x) => {
        return x._id === params.angleSetId;
      });
      const angleSetData = [];
      filteredAngleSet[0].angles.forEach((data, index) => {
        return angleSetData.push({ ...data.angleGlobal, imageSetsData: data });
      });
      setImageSet(angleSetData);
      setSequentialDetail(filteredAngleSet[0].angles);
    }
  };
  const onErrorGuidelineData = (err) => {};
  // const { data: guidelineData } = useGetGuidelineData(
  //   "guidelinesData",
  //   params.guidelineId,
  //   onSuccessGuidelineData,
  //   onErrorGuidelineData
  // );
  const { mutate: fetchGuidelineData } = useGetGuidelineData(
    onSuccessGuidelineData,
    onErrorGuidelineData
  );

  useEffect(() => {
    if (update) {
      fetchGuidelineData(params?.guidelineId);
    }
  }, [update]);

  const onSuccessGetAllAngles = (res) => {
    if (res.status === 200) {
      setAnglesList(res.data.data);
    }
  };
  const onErrorGetAllAngles = (err) => {
    message.error(err);
  };
  const { data, refetch } = useGetAllAngles(
    "getAllAngles",
    guide_selectedCategoryId,
    guide_selectedSubCategoryId,
    guide_selectedClientId,
    pageNum,
    pageSize,
    onSuccessGetAllAngles,
    onErrorGetAllAngles
  );
  const angleCreated = () => {
    setIsCreateAngle(false);
    refetch();
  };
  const handleDrop = (index) => {
    const newImageSet = [...imageSet];
    const [draggedItem] = newImageSet.splice(draggedItemIndex, 1);
    newImageSet.splice(index, 0, draggedItem);
    setImageSet(newImageSet);
    setDraggedItemIndex(null);
  };
  const sequenceUpdated = () => {
    setIsSequentialDetail(false);
  };
  const markAngleChangeUpdate = (selectedAngle, angleId, angleData) => {
    const imageSets = imageSet.map((angle, index) => {
      if (angle._id === selectedAngle) {
        return angleData;
      }
      return angle;
    });
    setImageSet(imageSets);
  };

  const getSequentialDetailModal = () => {
    return (
      <Modal
        title="Angles - Set"
        open={isSequentialDetails}
        footer={null}
        width="90%"
        height="90dvh"
        className="change_angle_view_modal_wrapper"
        onCancel={() => setIsSequentialDetail(false)}
        maskClosable={false}
      >
        <SequentialDetail
          imageData={imageSet}
          anglesList={groupByShootType(anglesList)}
          sequenceUpdated={sequenceUpdated}
          markAngleChangeUpdate={markAngleChangeUpdate}
          update={update}
        />
      </Modal>
    );
  };

  const getCreateAngelModal = () => {
    return (
      <Modal
        title="Create Angle"
        open={isCreateAngle}
        footer={null}
        width="60%"
        height="90dvh"
        className="create_angle"
        onCancel={() => setIsCreateAngle(false)}
      >
        <CreateAngel
          isAngleCreated={angleCreated}
          setIsCreateAngle={setIsCreateAngle}
        />
      </Modal>
    );
  };
  const handleAngleSet = (angle) => {
    let data = [...imageSet];
    const index = data.findIndex((item) => item._id === angle._id);
    if (index !== -1) {
      data.splice(index, 1);
    } else {
      data.push(angle);
    }
    setImageSet(data);
  };
  const angleListData = () => {
    const items = groupByShootType(anglesList).map((list, index) => ({
      key: `${index + 1}`,
      label: list.shootType,
      children: (
        <div className="image_box">
          {list.angles.map((angle, angleIndex) => (
            <div className="box" key={angleIndex}>
              <div
                className={`box_inner ${
                  imageSet?.some((item) => item._id === angle._id)
                    ? "active"
                    : ""
                }`}
                onClick={() => handleAngleSet(angle)}
              >
                <img src={angle?.image?.thumbPath?.url} alt={angle.name} />
              </div>
              <span>{angle.name}</span>{" "}
            </div>
          ))}
        </div>
      ),
    }));

    return items;
  };
  return (
    <div className="create_set_wrapper">
      <div className="left_section">
        <div className="header_wrapper">
          <div className="content_wrapper">
            <div className="title">Category</div>
            <div className="title_value">{guide_selectedCategoryName}</div>
          </div>
          <div className="content_wrapper">
            <div className="title">Sub Category</div>
            <div className="title_value">{guide_selectedSubCategoryName}</div>
          </div>
        </div>
        <div className="list_wrapper">
          <div className="list_card_wrapper">
            {imageSet.length > 0 ? (
              <div className="card_content">
                {imageSet.map((image, index) => (
                  <div
                    key={image.id}
                    className="image_container"
                    draggable
                    onDragStart={() => handleDragStart(index)}
                    onDragOver={handleDragOver}
                    onDrop={() => handleDrop(index)}
                  >
                    <div className="category">{image.shootType}</div>
                    <div className="image_wrapper">
                      <div
                        className="cross_icon_wrapper"
                        onClick={() => handleAngleSet(image)}
                      >
                        <CloseOutlined
                          style={{ fontSize: "10px", color: "black" }}
                        />
                      </div>
                      <img
                        src={image?.image?.thumbPath?.url}
                        alt={image.name}
                      />
                    </div>
                    <div className="angle_name">{image.name}</div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="empty_container">
                <Empty description={"Please select angle"} />
              </div>
            )}
          </div>
        </div>

        <div className="action_wrapper">
          {imageSet.length > 0 && (
            <button className="cancel_btn" onClick={() => setImageSet([])}>
              Cancel
            </button>
          )}
          <Button
            width="71px"
            height="40px"
            handleClick={() => setIsSequentialDetail(true)}
            text={!update ? "Add" : "Update"}
            isDisabled={imageSet.length > 0 ? false : true}
          />
        </div>
      </div>
      <div className="right_section">
        <div className="action_wrapper">
          <Button
            width="150px"
            height="40px"
            handleClick={() => setIsCreateAngle(true)}
            text="Create Angle"
            isDisabled={false}
          />
        </div>
        <Collapse
          defaultActiveKey={["1"]}
          ghost
          items={angleListData()}
          classNames="collapse_wrapper"
        />
      </div>
      {isSequentialDetails && getSequentialDetailModal()}
      {isCreateAngle && getCreateAngelModal()}
    </div>
  );
};

export default CreateSet;
